import * as React from "react";

const componentMap = {
  speedrun: Speedrun,
  achievement: Achievement,
  rank: Rank
};

interface AccomplishmentData {
  id: string;
  date: string;
  type: string;
  gameId?: string;
  speedrun?: any;
  rank?: any;
  achievement?: any;
}

interface AccomplishmentsProps {
  accomplishments: AccomplishmentData[];
  games: any;
}

export const Accomplishments = ({
  accomplishments,
  games
}: AccomplishmentsProps) => {
  const accomplishmentList = accomplishments.map(a => {
    const game = a.gameId ? games[a.gameId] : null;
    const bytNamn: Accomplishment = {
      game: game,
      date: a.date,
      type: a.type,
      speedrun: a.speedrun,
      rank: a.rank,
      achievement: a.achievement
    };
    return <Accomplishment accomplishment={bytNamn} key={a.id} />;
  });
  return (
    <div className="fb-row fb-jsa accomplishments">{accomplishmentList}</div>
  );
};

interface AccomplishmentProps {
  accomplishment: Accomplishment;
}
interface Accomplishment {
  game: Game;
  type: string;
  date: string;
  speedrun?: Speedrun;
  rank?: Rank;
  achievement?: Achievement;
}

interface Game {
  artUrl: string;
  title: string;
}

interface Speedrun {
  time: string;
  category: string;
}
interface Rank {
  title: string;
}
interface Achievement {
  title: string;
}

function Accomplishment({ accomplishment }: AccomplishmentProps) {
  const Component = componentMap[accomplishment.type];
  return (
    <div className="accomplishment fb-column fb-ac">
      <Component accomplishment={accomplishment} />
    </div>
  );
}

function Speedrun({ accomplishment }: AccomplishmentProps) {
  console.log(accomplishment);

  const speedrun = accomplishment.speedrun as Speedrun;

  return (
    <>
      <Game game={accomplishment.game} />
      <span className="accomplishment-icon speedrun-icon">🏃‍</span>
      <span className="speedrun-time">{speedrun.time}</span>
      <span>Speedrun {speedrun.category}</span>
      <span className="date">{accomplishment.date}</span>
    </>
  );
}
function Achievement({ accomplishment }: AccomplishmentProps) {
  const achievement = accomplishment.achievement as Achievement;

  return (
    <>
      <Game game={accomplishment.game} />
      <span className="accomplishment-icon achievement-icon">💪</span>
      <h3>{achievement.title}</h3>
      <span className="date">{accomplishment.date}</span>
    </>
  );
}
function Rank({ accomplishment }: AccomplishmentProps) {
  const rank = accomplishment.rank as Rank;

  return (
    <>
      <Game game={accomplishment.game} />
      <span className="accomplishment-icon rank-icon">🏅</span>
      <h3>{rank.title}</h3>
      <span className="date">{accomplishment.date}</span>
    </>
  );
}

interface GameProps {
  game: Game;
}

function Game({ game }: GameProps) {
  const { artUrl, title } = game;
  return (
    <>
      <img className="game-art" src={artUrl} alt={title + " game art"} />
      <h3>{title}</h3>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/Profile/Accomplishments.tsx